function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6,0C15.39,0,10.914,2.857,10.364,11.483c0.435,7.617,2.61,12.626,3.624,14.949c0.134,0.307,0.248,0.569,0.338,0.788c0.209,0.512-0.036,1.096-0.547,1.305C13.655,28.576,13.526,28.6,13.4,28.6c-0.394,0-0.768-0.234-0.926-0.621c-0.084-0.208-0.193-0.456-0.32-0.746c-0.944-2.167-2.856-6.568-3.58-13.144c-1.684,0.23-3.268,1.186-4.282,2.676c-0.935,1.374-2.22,4.396-0.327,9.19c4.44,11.657,9.672,13.396,12.797,14.435c0.354,0.117,0.679,0.225,0.966,0.338c1.336,0.534,4.155,0.646,6.284,0.646c3.595,0,13.424-0.498,15.695-2.768C43.614,34.701,45,22.641,45,13.5C45,3.28,40.771,0,27.6,0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M24.012,43.375c-5.052,0-6.538-0.594-7.018-0.786c-0.248-0.098-0.528-0.189-0.864-0.301c-0.215-0.071-0.443-0.147-0.681-0.229c0.669,3.724,1.199,5.305,1.972,6.077C18.952,49.547,21.644,50,28.5,50c7.157,0,10.164-0.691,11.079-2.523c0.826-1.525,1.171-4.748,1.315-7.271C37.437,43.212,26.262,43.375,24.012,43.375z"
});

function SvgBoxingGlove(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoxingGlove);
export default __webpack_public_path__ + "static/media/boxing-glove.91a0d835.svg";
export { ForwardRef as ReactComponent };